import type * as models from '../../../../models'

/**
 * {@link https://ngrx.io/docs State} of this feature
 */
export interface State {
  /**
   * Reference to a modal renderable widget
   *
   * @see {@link models.widget.Ref}
   */
  widgetRef?: models.widget.Ref
}
export namespace State {
  export const INITIAL: State = {}
}
